var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2907_8892",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 119
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118.89,
    height: 118.89,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2907_8892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.7912 82.7279L82.7265 75.7927L64.3976 57.4638V34.6765H54.49V61.4268L75.7912 82.7279ZM59.4438 108.983C52.5911 108.983 46.1512 107.682 40.1242 105.079C34.0971 102.48 28.8544 98.9515 24.396 94.4931C19.9376 90.0347 16.4089 84.792 13.8098 78.7649C11.2074 72.7378 9.90625 66.298 9.90625 59.4453C9.90625 52.5926 11.2074 46.1527 13.8098 40.1256C16.4089 34.0986 19.9376 28.8558 24.396 24.3975C28.8544 19.9391 34.0971 16.4087 40.1242 13.8063C46.1512 11.2072 52.5911 9.90771 59.4438 9.90771C66.2965 9.90771 72.7364 11.2072 78.7635 13.8063C84.7905 16.4087 90.0332 19.9391 94.4916 24.3975C98.95 28.8558 102.479 34.0986 105.078 40.1256C107.68 46.1527 108.981 52.5926 108.981 59.4453C108.981 66.298 107.68 72.7378 105.078 78.7649C102.479 84.792 98.95 90.0347 94.4916 94.4931C90.0332 98.9515 84.7905 102.48 78.7635 105.079C72.7364 107.682 66.2965 108.983 59.4438 108.983ZM59.4438 99.0753C70.4246 99.0753 79.7757 95.2163 87.4969 87.4984C95.2149 79.7771 99.0738 70.4261 99.0738 59.4453C99.0738 48.4644 95.2149 39.1134 87.4969 31.3922C79.7757 23.6742 70.4246 19.8152 59.4438 19.8152C48.463 19.8152 39.1136 23.6742 31.3956 31.3922C23.6744 39.1134 19.8138 48.4644 19.8138 59.4453C19.8138 70.4261 23.6744 79.7771 31.3956 87.4984C39.1136 95.2163 48.463 99.0753 59.4438 99.0753Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.06c2c06892bd65959a475f257f8fb4be.svg";
export { ForwardRef as ReactComponent };